/* REVAINE theme scripts: hero carousel, cart drawer, ajax cart, product gallery, mobile nav */
(function () {
  'use strict';
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-menu-toggle]');
      var nav = document.querySelector('[data-mobile-nav]');
      if (!toggle || !nav) return;
      e.preventDefault();
      e.stopPropagation();
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Toggle menu');
    });
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-mobile-nav] a');
      var nav = document.querySelector('[data-mobile-nav]');
      var toggle = document.querySelector('[data-menu-toggle]');
      if (!link || !nav) return;
      nav.classList.remove('is-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Toggle menu');
      }
    });
    document.addEventListener('click', function (e) {
      var nav = document.querySelector('[data-mobile-nav]');
      var toggle = document.querySelector('[data-menu-toggle]');
      if (!nav || !nav.classList.contains('is-open')) return;
      if (
        e.target.closest('[data-mobile-nav]') ||
        e.target.closest('[data-menu-toggle]')
      ) return;
      nav.classList.remove('is-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Toggle menu');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var nav = document.querySelector('[data-mobile-nav]');
      var toggle = document.querySelector('[data-menu-toggle]');
      if (!nav) return;
      nav.classList.remove('is-open');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Toggle menu');
      }
    });
  }
  /* ---------- Mobile search overlay ---------- */
  function rootPath() {
    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';
  }
  function initMobileSearch() {
    var overlay = document.querySelector('[data-rv-search-overlay]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.setAttribute('data-rv-search-overlay', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML =
        '<div class="rv-search-overlay__backdrop" data-rv-search-close></div>' +
        '<section class="rv-search-overlay__panel" role="dialog" aria-modal="true" aria-label="Search ReVaine">' +
          '<button type="button" class="rv-search-overlay__close" data-rv-search-close aria-label="Close search">×</button>' +
          '<div class="rv-search-overlay__eyebrow">SEARCH REVAINE</div>' +
          '<h2>Find what you are looking for.</h2>' +
          '<form action="' + rootPath() + 'search" method="get" role="search">' +
            '<input type="search" name="q" autocomplete="off" placeholder="Search jackets, hoodies, tees..." aria-label="Search products">' +
            '<input type="hidden" name="type" value="product">' +
            '<button type="submit">SEARCH</button>' +
          '</form>' +
        '</section>';
      document.body.appendChild(overlay);
    }
    if (!document.querySelector('[data-rv-search-overlay-style]')) {
      var style = document.createElement('style');
      style.setAttribute('data-rv-search-overlay-style', '');
      style.textContent =
        '[data-rv-search-overlay]{position:fixed;inset:0;z-index:99999;display:flex;justify-content:center;visibility:hidden;opacity:0;pointer-events:none;transition:opacity .2s ease,visibility .2s ease}' +
        '[data-rv-search-overlay].is-open{visibility:visible;opacity:1;pointer-events:auto}' +
        '.rv-search-overlay__backdrop{position:absolute;inset:0;background:rgba(9,16,25,.4);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}' +
        '.rv-search-overlay__panel{position:relative;box-sizing:border-box;width:min(92vw,620px);height:max-content;margin:65px 14px 0;padding:30px 22px 24px;background:#f5f2ed;color:#091019;border-radius:18px;box-shadow:0 22px 60px rgba(9,16,25,.2)}' +
        '.rv-search-overlay__close{position:absolute;right:14px;top:10px;width:34px;height:34px;border:0;background:transparent;font-size:28px;cursor:pointer;color:#091019}' +
        '.rv-search-overlay__eyebrow{font-size:10px;letter-spacing:.18em;font-weight:700;margin-bottom:10px}' +
        '.rv-search-overlay__panel h2{margin:0 35px 20px 0;font-size:27px;line-height:1.1}' +
        '.rv-search-overlay__panel form{display:flex;gap:8px}' +
        '.rv-search-overlay__panel input[type=search]{flex:1;min-width:0;height:48px;padding:0 15px;border:1px solid rgba(9,16,25,.18);border-radius:24px;background:#fff;font:inherit;box-sizing:border-box}' +
        '.rv-search-overlay__panel form button{height:48px;padding:0 18px;border:0;border-radius:24px;background:#091019;color:#fff;font-size:11px;font-weight:700;cursor:pointer}' +
        '@media(max-width:600px){.rv-search-overlay__panel{width:calc(100vw - 28px);margin-top:55px;padding:27px 16px 18px}.rv-search-overlay__panel h2{font-size:24px}.rv-search-overlay__panel form{display:block}.rv-search-overlay__panel input[type=search],.rv-search-overlay__panel form button{width:100%}.rv-search-overlay__panel form button{margin-top:8px}}';
      document.head.appendChild(style);
    }
    function openSearch() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var input = overlay.querySelector('input[type="search"]');
      if (input) window.setTimeout(function () { input.focus(); }, 30);
    }
    function closeSearch() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var searchButton = target.closest('[data-search-open]');
      var menuSearchLink = target.closest('[data-mobile-nav] a');
      if (menuSearchLink) {
        var href = menuSearchLink.getAttribute('href') || '';
        var label = (menuSearchLink.textContent || '').trim().toLowerCase();
        if (
          label === 'search' ||
          href === '/search' ||
          href.indexOf('/search?') === 0
        ) {
          searchButton = menuSearchLink;
        }
      }
      if (searchButton) {
        event.preventDefault();
        var nav = document.querySelector('[data-mobile-nav]');
        var toggle = document.querySelector('[data-menu-toggle]');
        if (nav) nav.classList.remove('is-open');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Toggle menu');
        }
        openSearch();
        return;
      }
      if (target.closest('[data-rv-search-close]')) closeSearch();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeSearch();
      }
    });
  }
  /* ---------- Hero carousel ---------- */
  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var slides = Array.prototype.slice.call(
        root.querySelectorAll('[data-slide]')
      );
      if (slides.length === 0) return;
      var dots = Array.prototype.slice.call(
        root.querySelectorAll('[data-dot]')
      );
      var frame = root.querySelector('[data-carousel-frame]');
      var delay = parseInt(root.dataset.autoplay || '5000', 10);
      var index = 0;
      var timer = null;
      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
          s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
        });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
          d.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
        if (frame) {
          frame.classList.toggle(
            'is-racing',
            slides[index].dataset.theme === 'racing'
          );
        }
      }
      function next() { show(index + 1); }
      function prev() { show(index - 1); }
      function start() {
        stop();
        if (delay > 0 && slides.length > 1) {
          timer = setInterval(next, delay);
        }
      }
      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }
      root.querySelectorAll('[data-carousel-next]').forEach(function (button) {
        button.addEventListener('click', function () {
          next();
          start();
        });
      });
      root.querySelectorAll('[data-carousel-prev]').forEach(function (button) {
        button.addEventListener('click', function () {
          prev();
          start();
        });
      });
      dots.forEach(function (dot, n) {
        dot.addEventListener('click', function () {
          show(n);
          start();
        });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          next();
          start();
        }
        if (event.key === 'ArrowLeft') {
          prev();
          start();
        }
      });
      var startX = null;
      root.addEventListener('touchstart', function (event) {
        if (!event.changedTouches.length) return;
        startX = event.changedTouches[0].clientX;
        stop();
      }, { passive: true });
      root.addEventListener('touchend', function (event) {
        if (startX === null || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          dx < 0 ? next() : prev();
        }
        startX = null;
        start();
      }, { passive: true });
      show(0);
      start();
    });
  }
  /* ---------- Cart helpers ---------- */
  function fetchCart() {
    return fetch(rootPath() + 'cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    });
  }
  function money(cents) {
    var format = window.theme && window.theme.moneyFormat
      ? window.theme.moneyFormat
      : '{{amount}}';
    var amount;
    if (format.indexOf('amount_no_decimals') > -1) {
      amount = Math.round(cents / 100).toString();
    } else {
      amount = (cents / 100).toFixed(2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }
  function renderDrawer(cart) {
    var body = document.querySelector('[data-cart-body]');
    var footer = document.querySelector('[data-cart-footer]');
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML =
        '<p class="muted" style="padding:24px 0;font-size:.9rem">Your bag is empty.</p>';
      if (footer) footer.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      return (
        '<div class="cart-line" style="padding:14px 0;border-top:1px solid var(--border)">' +
          (item.image
            ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_160x$1') +
              '" alt="' + item.product_title + '">'
            : '') +
          '<div style="flex:1;min-width:0">' +
            '<p style="margin:0;font-weight:600;font-size:.85rem">' +
              item.product_title +
            '</p>' +
            '<p class="muted" style="margin:2px 0;font-size:.75rem">' +
              (item.variant_title || '') +
            '</p>' +
            '<div class="qty" style="margin-top:6px">' +
              '<button type="button" data-line-change="' + item.key +
                '" data-qty="' + (item.quantity - 1) +
                '" aria-label="Decrease quantity">−</button>' +
              '<input value="' + item.quantity +
                '" readonly aria-label="Quantity">' +
              '<button type="button" data-line-change="' + item.key +
                '" data-qty="' + (item.quantity + 1) +
                '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<span style="font-weight:600;font-size:.85rem">' +
            money(item.final_line_price) +
          '</span>' +
        '</div>'
      );
    }).join('');
    if (footer) {
      footer.innerHTML =
        '<div style="display:flex;justify-content:space-between;padding:14px 0;font-weight:600">' +
          '<span>Subtotal</span><span>' + money(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="muted" style="margin:0 0 12px;font-size:.75rem">' +
          'Taxes and shipping calculated at checkout.' +
        '</p>' +
        '<a class="btn btn--full" href="' + rootPath() + 'checkout">Checkout</a>' +
        '<a class="btn btn--ghost btn--full" style="margin-top:8px" href="' +
          rootPath() + 'cart">View bag</a>';
    }
  }
  function openDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart().then(renderDrawer).catch(function (error) {
      console.error('ReVaine cart could not refresh:', error);
    });
  }
  function closeDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function initCart() {
    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-cart-open]');
      if (open) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (event.target.closest('[data-cart-close]')) {
        closeDrawer();
        return;
      }
      var change = event.target.closest('[data-line-change]');
      if (change) {
        event.preventDefault();
        var body = {
          id: change.dataset.lineChange,
          quantity: parseInt(change.dataset.qty, 10)
        };
        fetch(rootPath() + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to update cart');
          return response.json();
        })
        .then(renderDrawer)
        .catch(function (error) {
          console.error('ReVaine cart update failed:', error);
        });
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });
    document.querySelectorAll('form.ajax-cart').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[type="submit]');
        if (button) button.disabled = true;
        fetch(rootPath() + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to add product');
          return response.json();
        })
        .then(function () {
          openDrawer();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (button) button.disabled = false;
        });
      });
    });
    fetchCart().then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    }).catch(function () {});
  }
  /* ---------- Product page ---------- */
  function initProduct() {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var thumbs = root.querySelectorAll('[data-thumb]');
    var main = root.querySelector('[data-main-image]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main) {
          main.src = thumb.dataset.full;
          main.alt = thumb.dataset.alt || '';
        }
        thumbs.forEach(function (other) {
          other.setAttribute('aria-current', 'false');
        });
        thumb.setAttribute('aria-current', 'true');
      });
    });
    var variantsEl = root.querySelector('[data-variants]');
    if (!variantsEl) return;
    var variants;
    try {
      variants = JSON.parse(variantsEl.textContent || '[]');
    } catch (error) {
      console.error('ReVaine product variants could not be parsed:', error);
      return;
    }
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var addBtn = root.querySelector('[data-add-button]');
    function selected() {
      return Array.prototype.map.call(
        root.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          var select = group.querySelector('select');
          return checked ? checked.value : (select ? select.value : null);
        }
      );
    }
    function update() {
      var chosen = selected();
      var match = variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return chosen[index] === null || chosen[index] === option;
        });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('[data-option-index] input, [data-option-index] select')
      .forEach(function (input) {
        input.addEventListener('change', update);
      });
    root.querySelectorAll('[data-qty-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = root.querySelector('[data-qty-input]');
        if (!input) return;
        var value = parseInt(input.value, 10) || 1;
        value += parseInt(button.dataset.qtyChange, 10);
        input.value = Math.max(1, value);
      });
    });
    update();
  }
  /* ---------- Existing predictive search dialog ---------- */
  function initSearchDialog() {
    var dialog = document.querySelector('[data-search-dialog]');
    if (!dialog) return;
    var input = dialog.querySelector('[data-search-input]');
    var results = dialog.querySelector('[data-search-results]');
    var timer = null;
    var token = 0;
    function open() {
      dialog.hidden = false;
      document.body.style.overflow = 'hidden';
      if (input) input.focus();
    }
    function close() {
      dialog.hidden = true;
      document.body.style.overflow = '';
    }
    function render(products, term) {
      if (!results) return;
      if (!products.length) {
        results.innerHTML =
          '<p class="search-dialog__empty">No products match “' +
          term + '”.</p>';
        return;
      }
      results.innerHTML = products.slice(0, 8).map(function (product) {
        var image = product.featured_image && product.featured_image.url
          ? '<img src="' + product.featured_image.url + '" alt="' +
            (product.featured_image.alt || product.title) + '" loading="lazy">'
          : '';
        return (
          '<a class="search-result" href="' + product.url + '">' +
            image +
            '<span style="flex:1;min-width:0">' +
              '<p class="search-result__title">' + product.title + '</p>' +
              '<p class="search-result__meta">' + (product.type || '') + '</p>' +
            '</span>' +
            '<span style="font-weight:600;font-size:.85rem">' +
              (product.price ? money(product.price) : '') +
            '</span>' +
          '</a>'
        );
      }).join('');
    }
    function search(term) {
      var requestToken = ++token;
      var url = rootPath() + 'search/suggest.json?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=8' +
        '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed');
          return response.json();
        })
        .then(function (data) {
          if (requestToken !== token) return;
          var products = data.resources &&
            data.resources.results &&
            data.resources.results.products || [];
          render(products, term);
        })
        .catch(function () {});
    }
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-open]')) {
        event.preventDefault();
        open();
        return;
      }
      if (event.target.closest('[data-search-close]')) {
        event.preventDefault();
        close();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !dialog.hidden) close();
    });
    if (input) {
      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(timer);
        if (term.length < 2) {
          if (results) results.innerHTML = '';
          return;
        }
        timer = setTimeout(function () {
          search(term);
        }, 200);
      });
    }
  }
  /* ---------- Mobile scroll header / bottom navigation ---------- */
  function initMobileScrollNavigation() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var header = document.querySelector('.header');
    var bottomNav = document.querySelector('[data-rv-mobile-bottom-nav]');
    if (!header || !bottomNav) return;
    if (header.dataset.rvScrollNavigationReady === 'true') return;
    header.dataset.rvScrollNavigationReady = 'true';
    var lastScrollY = window.scrollY || 0;
    var ticking = false;
    var topThreshold = 24;
    var directionThreshold = 8;
    function showHeader() {
      header.classList.remove('rv-header-hidden');
      bottomNav.classList.remove('rv-bottom-visible');
    }
    function showBottomNavigation() {
      header.classList.add('rv-header-hidden');
      bottomNav.classList.add('rv-bottom-visible');
    }
    function updateNavigation() {
      ticking = false;
      if (!window.matchMedia('(max-width: 749px)').matches) {
        showHeader();
        return;
      }
      var currentScrollY = window.scrollY || 0;
      if (currentScrollY <= topThreshold) {
        showHeader();
        lastScrollY = currentScrollY;
        return;
      }
      var mobileMenu = document.querySelector('[data-mobile-nav]');
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        showHeader();
        lastScrollY = currentScrollY;
        return;
      }
      var difference = currentScrollY - lastScrollY;
      if (Math.abs(difference) < directionThreshold) return;
      if (difference > 0) showBottomNavigation();
      else showHeader();
      lastScrollY = currentScrollY;
    }
    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateNavigation);
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function () {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        showHeader();
      }
    });
    showHeader();
  }
  /* ---------- Initialize ---------- */
  ready(function () {
    initMobileNav();
    initMobileSearch();
    initCarousel();
    initCart();
    initProduct();
    initSearchDialog();
    initMobileScrollNavigation();
  });
})();